import React from "react";
import { Link } from "react-router-dom";
import { FaBars, FaChevronLeft } from "react-icons/fa";
// import tlfLogo from "../../images/tlf_logo.svg";
const tlfLogo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf_logo_2.svg";

// Admin dashboard top header: the sidebar toggle and the TLF brand. Keeping the
// toggle here (instead of floating over the page) lets the content keep
// symmetric gutters in both the expanded and collapsed sidebar states.
const HeaderBar = ({ sidebarVisible, onToggleSidebar }) => {
  return (
    <header
      className="admin-header d-flex align-items-center shadow-sm px-3"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 80,
        backgroundColor: "#060606",
        gap: 16,
        zIndex: 1030, // above the sidebar (z-index: 100)
      }}
    >
      <button
        type="button"
        onClick={onToggleSidebar}
        className="d-inline-flex align-items-center justify-content-center"
        style={{
          width: 40,
          height: 40,
          border: "none",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.1)",
          color: "#fff",
          cursor: "pointer",
        }}
        aria-label={sidebarVisible ? "Hide menu" : "Show menu"}
        title={sidebarVisible ? "Hide menu" : "Show menu"}
      >
        {sidebarVisible ? <FaChevronLeft size={18} /> : <FaBars size={18} />}
      </button>

      <Link
        to="/admin/dashboard"
        className="d-inline-flex align-items-center"
        aria-label="The Luxury Fleet admin"
      >
        <img
          src={tlfLogo}
          alt="The Luxury Fleet"
          style={{ height: 55, width: "auto" }}
        />
      </Link>
    </header>
  );
};

export default HeaderBar;
